import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "missing-rates-modal",
  "data-toggle": "modal"
}
const _hoisted_2 = { class: "modal-dialog modal-xl" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", {
    class: "modal-title",
    id: "missing-rates-modal-label"
  }, " Add missing rates "),
  /*#__PURE__*/_createElementVNode("div", {
    class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2x" })
  ])
], -1)
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { class: "pb-2 fs-6 fw-bold" }
const _hoisted_8 = { class: "modal-footer" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-light",
  "data-bs-dismiss": "modal"
}, " Cancel ", -1)
const _hoisted_10 = ["disabled"]
const _hoisted_11 = {
  key: 0,
  class: "spinner-border spinner-border-sm"
}
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Save ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_RatesDataTable = _resolveComponent("RatesDataTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          (_ctx.loading)
            ? (_openBlock(), _createBlock(_component_LoadingSpinner, { key: 0 }))
            : _createCommentVNode("", true),
          (!_ctx.loading && _ctx.hasError)
            ? (_openBlock(), _createBlock(_component_el_empty, {
                key: 1,
                description: "There was an error"
              }))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.missingSkills, (missingRateCollection, index) => {
                  return (_openBlock(), _createElementBlock("div", { key: index }, [
                    _createElementVNode("div", _hoisted_7, " Branch: " + _toDisplayString(_ctx.branchName(index)), 1),
                    _createVNode(_component_RatesDataTable, {
                      branchID: index,
                      missingRatesSkills: missingRateCollection,
                      isModal: true,
                      onUpdateModalValues: _ctx.handleTableInput
                    }, null, 8, ["branchID", "missingRatesSkills", "onUpdateModalValues"])
                  ]))
                }), 128))
              ]))
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _withDirectives(_createElementVNode("button", {
            type: "button",
            class: "btn btn-light-primary",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleUseOnce && _ctx.handleUseOnce(...args)))
          }, " Use once ", 512), [
            [_vShow, false]
          ]),
          _createElementVNode("button", {
            type: "button",
            disabled: _ctx.isSavingRates,
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleSave && _ctx.handleSave(...args))),
            class: "btn btn-light-success"
          }, [
            (_ctx.isSavingRates)
              ? (_openBlock(), _createElementBlock("span", _hoisted_11))
              : _createCommentVNode("", true),
            _hoisted_12
          ], 8, _hoisted_10)
        ])
      ])
    ])
  ]))
}